const React = require("react")
const Layout = require("./src/components/layout")

// Contrôler le comportement de scroll lors de la navigation
exports.shouldUpdateScroll = ({ routerProps, getSavedScrollPosition }) => {
    const location = routerProps && routerProps.location;

    // 1. Ancre (#section) → laisser Gatsby défiler vers l'élément correspondant.
    if (location && location.hash) {
        return true;
    }

    // 2. Retour / avancer (bouton précédent du navigateur) → restaurer la
    //    position de scroll que Gatsby a sauvegardée pour cette page.
    const savedPosition = location && getSavedScrollPosition && getSavedScrollPosition(location);
    if (savedPosition) {
        return savedPosition;
    }

    // 3. Nouvelle navigation → haut de page.
    return [0, 0];
}

// Logs when the client route changes
exports.onRouteUpdate = ({ location, prevLocation }) => {
    // Le scroll est géré par shouldUpdateScroll (haut de page en navigation
    // neuve, restauration au retour, ancre vers la section). On ne force donc
    // plus scrollTo(0, 0) ici, ce qui écrasait la restauration au retour.

    const data = window.dataLayer

    if (typeof data === `object`) {
        const eventName = `gatsbyRouteChange`
        data.push({ event: eventName })

        pushUTMToDataLayer();
    }
}

const pushUTMToDataLayer = () => {
    // Récupérer les UTM depuis l'URL
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = {
        utm_campaign: urlParams.get("utm_campaign"),
        utm_term: urlParams.get("utm_term"),
        gad_source: urlParams.get("gad_source"),
    };

    // Vérifier si des UTM sont présents dans l'URL
    const hasUTM = Object.values(utmParams).some((val) => val !== null);

    if (hasUTM) {
        // Pousser dans le dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "utm_params_received",
            utm_params: utmParams,
        });
    }
};


